import PropTypes from "prop-types";
export const linkProp = PropTypes.shape({
  account: PropTypes.string.isRequired,
  useRoles: PropTypes.bool,
  directLink: PropTypes.string,
  rolePrefix: PropTypes.string,
  profilePrefix: PropTypes.string,
  description: PropTypes.string,
});
